function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.2202 17.5751H30.3086L27.9032 13.5324C27.6679 13.1372 27.2422 12.895 26.7824 12.895H19.2174C18.7576 12.895 18.3318 13.1372 18.0966 13.5324L15.6913 17.5751H11.7825V16.6841C11.7825 15.9635 11.1986 15.3792 10.4783 15.3792H5.65226C4.93181 15.3792 4.34798 15.9635 4.34798 16.6841V17.5751H3.77981C1.96829 17.5751 0.5 19.0442 0.5 20.8563V44.6137C0.5 46.4259 1.96829 47.895 3.77967 47.895H42.2202C44.0316 47.895 45.5 46.4259 45.5 44.6137V20.8563C45.5001 19.0442 44.0316 17.5751 42.2202 17.5751ZM22.9999 42.0748C17.844 42.0748 13.6644 37.8933 13.6644 32.7349C13.6644 27.5767 17.844 23.395 22.9999 23.395C28.1558 23.395 32.3355 27.5767 32.3355 32.7349C32.3355 37.8933 28.1558 42.0748 22.9999 42.0748ZM36.087 24.3399H40.1739C40.8944 24.3399 41.4784 23.7557 41.4784 23.0349C41.4784 22.3141 40.8945 21.7299 40.1739 21.7299H36.087C35.3667 21.7299 34.7827 22.3141 34.7827 23.0349C34.7827 23.7557 35.3667 24.3399 36.087 24.3399Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 32.395,
  r: 6.5,
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36.4074 24.9193L22.6263 22.9032L36.3286 20.4074L38.3447 6.62641L40.8405 20.3287L54.6215 22.3447L40.9192 24.8405L38.9031 38.6215L36.4074 24.9193Z",
  fill: "#CFB9FF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M36.4074 24.9193L22.6263 22.9032L36.3286 20.4074L38.3447 6.62641L40.8405 20.3287L54.6215 22.3447L40.9192 24.8405L38.9031 38.6215L36.4074 24.9193Z",
  stroke: "#131415"
});

function SvgStarCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 48,
    viewBox: "0 0 62 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarCamera);
export default __webpack_public_path__ + "static/media/star-camera.afb0949e.svg";
export { ForwardRef as ReactComponent };